module.exports = __webpack_public_path__ + "img/store_outside.1b8f2e83.jpg";